// components/TableHeader.jsx
import Checkbox from "./Checkbox";


const TableHeader = ({isAllSelected, onSelectAll}) => {
    return (
      <thead className="bg-gray-20">
        <tr>
          <th className="text-center border border-gray-300 w-[40px]">
          <Checkbox
            checked={isAllSelected}
            onChange={onSelectAll}
          />
          </th>
          {/* <th className="p-2 text-left border border-gray-300 w-[50px]">ID</th> */}
          <th className="p-2 text-left cursor-pointer border border-gray-300 break-words w-[190px]">Task ID</th>
          <th className="p-2 text-left border border-gray-300 break-words w-[350px]">File Name (Lang Pair)</th>
          <th className="p-2 text-left border border-gray-300 w-[70px]">Words</th>
          <th className="p-2 text-left border border-gray-300 w-[160px]">Assigned to</th>
          <th className="p-2 text-left border border-gray-300 break-all w-[190px]">Status</th>
          <th className="p-2 text-left border border-gray-300 break-all w-[130px]">Action</th>
        </tr>
      </thead>
    );
  };
  
  export default TableHeader;
  
